import {
  USER_LOGIN_REQUEST,
  USER_LOGIN_SUCCESS,
  USER_LOGIN_FAIL,
  ADMIN_LOGIN_REQUEST,
  ADMIN_LOGIN_SUCCESS,
  ADMIN_LOGIN_FAIL,
  USER_LOGOUT,
  USER_REGISTER_REQUEST,
  USER_REGISTER_SUCCESS,
  USER_REGISTER_FAIL,
  UPDATE_PROFILE_REQUEST,
  UPDATE_PROFILE_SUCCESS,
  UPDATE_PROFILE_FAIL,
  GET_PROFILE_DETAILS_REQUEST,
  GET_PROFILE_DETAILS_SUCCESS,
  GET_PROFILE_DETAILS_FAIL,
  USER_PROFILE_UPDATE_REQUEST,
  USER_PROFILE_UPDATE_SUCCESS,
  USER_PROFILE_UPDATE_FAIL,
  CONTACT_US_REQUEST,
  CONTACT_US_SUCCESS,
  CONTACT_US_FAIL,
} from "../types/userTypes";

export const userLoginReducer = (state = {}, action) => {
  switch (action.type) {
    case USER_LOGIN_REQUEST:
      return { loading: true };
    case USER_LOGIN_SUCCESS:
      return { loading: false, userInfo: action.payload };
    case USER_LOGIN_FAIL:
      return { loading: false, error: action.payload };
    // case ADMIN_LOGIN_REQUEST:
    //   return { loadingAdmin: true };
    // case ADMIN_LOGIN_SUCCESS:
    //   return { loadingAdmin: false, adminInfo: action.payload };
    // case ADMIN_LOGIN_FAIL:
    //   return { loadingAdmin: false, errorAdmin: action.payload };

    case USER_LOGOUT:
      return {};
    case USER_REGISTER_REQUEST:
      return { loadingRegister: true };
    case USER_REGISTER_SUCCESS:
      return { loadingRegister: false, userInfo: action.payload };
    case USER_REGISTER_FAIL:
      return { loadingRegister: false, errorRegister: action.payload };
    default:
      return state;
  }
};

export const adminLoginReducer = (state = {}, action) => {
  switch (action.type) {
    case ADMIN_LOGIN_REQUEST:
      return { loadingAdmin: true };
    case ADMIN_LOGIN_SUCCESS:
      return { loadingAdmin: false, adminInfo: action.payload };
    case ADMIN_LOGIN_FAIL:
      return { loadingAdmin: false, errorAdmin: action.payload };
    case USER_LOGOUT:
      return {};
    default:
      return state;
  }
};

// export const userProfileReducer = (state = { user: {} }, action) => {
//   switch (action.type) {
//     case USER_PROFILE_REQUEST:
//       return { ...state, loading: true };
//     case USER_PROFILE_SUCCESS:
//       return { loading: false, user: action.payload };
//     case USER_PROFILE_FAIL:
//       return { loading: false, error: action.payload };
//     case USER_PROFILE_RESET:
//       return {};
//     default:
//       return state;
//   }
// };

// export const updateProfileReducer = (state = { updatedUser: {} }, action) => {
//   switch (action.type) {
//     case UPDATE_PROFILE_REQUEST:
//       return { loading: true };
//     case UPDATE_PROFILE_SUCCESS:
//       return { loading: false, success: true, updatedUser: action.payload };
//     case UPDATE_PROFILE_FAIL:
//       return { loading: false, error: action.payload };
//     default:
//       return state;
//   }
// };
export const getProfileDetails = (state = {}, action) => {
  switch (action.type) {
    case GET_PROFILE_DETAILS_REQUEST:
      return { loading: true };
    case GET_PROFILE_DETAILS_SUCCESS:
      return { loading: false, user: action.payload };
    case GET_PROFILE_DETAILS_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// export const editUserReducer = (state = { user: {} }, action) => {
//   switch (action.type) {
//     case EDIT_USER_REQUEST:
//       return { loading: true };
//     case EDIT_USER_SUCCESS:
//       return { loading: false, success: true, user: action.payload };
//     case EDIT_USER_FAIL:
//       return { loading: false, error: action.payload };
//     case EDIT_USER_RESET:
//       return {};
//     default:
//       return state;
//   }
// };

export const userProfileUpdate = (state = {}, action) => {
  switch (action.type) {
    case USER_PROFILE_UPDATE_REQUEST:
      return { loading: true };
    case USER_PROFILE_UPDATE_SUCCESS:
      return { loading: false, update: action.payload };
    case USER_PROFILE_UPDATE_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const contactUsReducer = (state = {}, action) => {
  switch (action.type) {
    case CONTACT_US_REQUEST:
      return { loading: true };
    case CONTACT_US_SUCCESS:
      return { loading: false, success: action.payload };
    case CONTACT_US_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};
